import * as React from "react";
import styled, { css } from "styled-components";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import { ExternalLink } from "components/common";
const StyledAlert = styled(Alert)(
  () => css`
    margin-top: 0;
  `
);
const StyledOl = styled.ol(
  ({ theme }) => css`
    padding-left: 20px;

    > li {
      margin-bottom: ${theme.spacings.sm};
    }

    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const AzureRepositorySetupInfo = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", title: "Setting up an Azure Blob Storage repository" }, /* @__PURE__ */ React.createElement(StyledOl, null, /* @__PURE__ */ React.createElement("li", null, "Create a storage account and a blob container. See Microsoft\u2018s documentation on", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://learn.microsoft.com/en-us/azure/storage/blobs/storage-quickstart-blobs-portal" }, "creating a container"), "."), /* @__PURE__ */ React.createElement("li", null, "Add the storage account name and key to the OpenSearch keystore, because OpenSearch writes the snapshots. See Microsoft\u2018s documentation on", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://learn.microsoft.com/en-us/azure/storage/common/storage-account-keys-manage" }, "storage account keys"), "."), /* @__PURE__ */ React.createElement("li", null, "Give ", productName, " read access to the container. Enter the account name and key, or choose Automatic to use", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://learn.microsoft.com/en-us/azure/developer/java/sdk/authentication/credential-chains#defaultazurecredential-overview" }, "DefaultAzureCredential"), " ", "on each ", productName, " node."), /* @__PURE__ */ React.createElement("li", null, "Enter the name of the container and the base path below.")));
};
export default AzureRepositorySetupInfo;
